import { useCallback, MutableRefObject } from "react";
import { GridFilterModel, GridSortModel } from "@mui/x-data-grid";
import { CustomDataGridWithMultipleFiltersProps } from "../../Interfaces/CustomDataGrid.interfaces";

export const useDataGridEventHandlers = (
  props: CustomDataGridWithMultipleFiltersProps,
  enableUrlParams: boolean,
  updateUrlParams: any,
  getTableStateFromUrl: any,
  isUpdatingQuickFilterRef: MutableRefObject<boolean>,
  activeFieldRef: MutableRefObject<string>,
  handleFilterChange: (newFilterModel: GridFilterModel) => void
) => {
  const onFilterChange = useCallback(
    (newFilterModel: GridFilterModel) => {
      if (isUpdatingQuickFilterRef.current) {
        return;
      }

      activeFieldRef.current = newFilterModel.items[0]?.field;
      if (enableUrlParams) {
        const { items, logicOperator } = getTableStateFromUrl() || { items: [], logicOperator: undefined };
        updateUrlParams({
          items: items || [],
          logicOperator,
          quickFilterValues: newFilterModel.quickFilterValues,
          quickFilterLogicOperator: newFilterModel.quickFilterLogicOperator
        });
      }
      props.setFilterOptions?.({ ...newFilterModel });
      handleFilterChange(newFilterModel);
    },
    [enableUrlParams, updateUrlParams, props.setFilterOptions, getTableStateFromUrl, handleFilterChange]
  );

  const onSortModelChange = useCallback(
    (sortModel: GridSortModel) => props.setSortOptions?.([...sortModel]),
    [props.setSortOptions]
  );

  return { onFilterChange, onSortModelChange };
};
